module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/人才理念.343c03a2.jpg";